var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.steps),function(stepData){return [(stepData.slot === _vm.step)?_vm._t(stepData.stepNumber):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }